export class FikoYTId extends String {
    constructor(value?: string) {
        let timestamp = (new Date().getTime() / 1000 | 0).toString(16);
        timestamp = timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => {
            // tslint:disable-next-line:no-bitwise
            return (Math.random() * 16 | 0).toString(16);
        }).toLowerCase();

        super(value ?? timestamp);  // String constructor'ını çağırıyoruz
    }

}